import { UseFormReturn } from "react-hook-form";

import { DocumentsFormValues } from "src/brand/EC/components/folder/DocumentsUploadFieldset";
import DocumentIcon from "src/core/assets/images/icons/document.svg?react";
import { Button } from "src/core/components/ui/button";
import { cn } from "src/core/lib/utils";

export const UploadButton = ({
  disabled,
  isExistingChecked,
  onChange,
  doc,
  form,
  fileErrors,
  label,
  isLoading = false,
}: {
  disabled: boolean;
  isExistingChecked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  doc: { code: string };
  form: UseFormReturn<DocumentsFormValues>;
  fileErrors: Record<string, string>;
  label: string;
  isLoading?: boolean;
}) => {
  return (
    <div>
      <Button
        className={cn(
          "w-full justify-start text-left group",
          fileErrors[doc.code] && "border-alert"
        )}
        onClick={(e) => {
          e.preventDefault();
          if (!disabled && !isExistingChecked) {
            document.getElementById(`file-upload-${doc.code}`)?.click();
          }
        }}
        variant="upload"
        size="small"
        disabled={disabled || isExistingChecked}
        loading={isLoading}
      >
        <label htmlFor={`file-upload-${doc.code}`} className="upload-doc-label">
          <DocumentIcon className="text-input group-hover:text-blue-completed" />
          <div>{label}</div>
        </label>
      </Button>
      {!disabled && !isExistingChecked && (
        <input
          id={`file-upload-${doc.code}`}
          type="file"
          className="sr-only"
          {...form.register(`documents.${doc.code}.file`)}
          onChange={onChange}
          disabled={disabled}
        />
      )}
    </div>
  );
};
